import { type Component, createSignal, onMount, Show } from "solid-js"
import { AppRoutes } from "../../shared/app-routes"
import { useTracking } from "../../shared/providers/tracking.provider"
import Footer from "../shared/components/Footer"
import WebinarHeadline from "./WebinarHeadline"
import WebinarOfferingBox from "./WebinarOfferingBox"
import WebinarStickyCta from "./WebinarStickyCta"
import EmailDisclaimerDialog from "../shared/components/EmailDisclaimerDialog"
import CheckoutUnavailableDialog from "../shared/components/CheckoutUnavailableDialog"
import SimpleTopBar from "../thanks/SimpleTopBar"
import { useWebinarCheckout } from "../shared/use-webinar-checkout"

const Webinar: Component = () => {
  const { setVariant, trackOfferCtaClicked } = useTracking()
  const [showDisclaimer, setShowDisclaimer] = createSignal(false)
  const [isInlineCtaVisible, setIsInlineCtaVisible] = createSignal(true)

  onMount(() => {
    setVariant("root")
  })

  const { product, showCheckout, checkoutUnavailable, markCheckoutUnavailable } =
    useWebinarCheckout(AppRoutes.Webinar)

  const attemptToPurchase = (): void => {
    trackOfferCtaClicked(product)
    if (!product) {
      markCheckoutUnavailable()
      return
    }
    setShowDisclaimer(true)
  }

  return (
    <div class='relative flex flex-col'>
      <Show when={showDisclaimer()}>
        <EmailDisclaimerDialog
          confirm={() => {
            setShowDisclaimer(false)
            void showCheckout()
          }}
        />
      </Show>
      <Show when={checkoutUnavailable()}>
        <CheckoutUnavailableDialog />
      </Show>
      <div class='min-h-screen flex flex-col' style="background: radial-gradient(44.49% 44.49% at 50% 55.51%, #213943 0%, #15262D 100%)">
        <SimpleTopBar />
        <div class='flex-1 flex items-center w-full px-4 sm:px-10 lg:px-20 pt-10 pb-[124px]'>
          <div class='flex flex-col items-center w-full max-w-[800px] mx-auto gap-10'>
            <WebinarHeadline />
            <WebinarOfferingBox
              showCheckout={attemptToPurchase}
              offeringPrice={300}
              showButton={true}
              onCtaVisibilityChange={setIsInlineCtaVisible}
            />
          </div>
        </div>
      </div>
      <Footer />
      <Show when={!isInlineCtaVisible()}>
        <WebinarStickyCta showCheckout={attemptToPurchase} offeringPrice={300} />
      </Show>
    </div>
  )
}

export default Webinar
